"use client";
import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import { motion } from "framer-motion";

const ContactPage = () => {
  const heroImage = `${process.env.PUBLIC_URL}/images/Hero/contacthero.webp`;

  return (
    <div className="bg-white text-black min-h-screen font-body">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
<section
  id="hero"
  className="relative h-[60vh] flex flex-col justify-center items-center overflow-hidden bg-black"
>
  <img
    src={heroImage}
    alt="Contact Hero"
    className="absolute inset-0 h-full w-full object-cover"
  />
  <div className="absolute inset-0 bg-black/45" />

  <motion.div
    className="relative z-10 text-center px-6 text-white"
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1, ease: 'easeOut' }}
  >
    <h1 className="max-w-[92vw] text-center text-[clamp(2.5rem,10vw,7rem)] leading-[0.95] break-words font-heading font-light mb-4 tracking-wide">
      GET IN TOUCH
    </h1>
  </motion.div>
</section>




      {/* CONTENT SECTION */}
      <section className="py-24 px-8 md:px-20 bg-white text-gray-800">
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1.4fr] gap-20 max-w-[1600px] mx-auto items-start">
          
          {/* LEFT COLUMN — INFO + MAP */}
          <div className="flex flex-col space-y-16">
            {/* Contact Info */}
            <motion.div
              className="space-y-6"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              
            </motion.div>

            {/* Google Map */}
            <motion.div
              className="w-full h-[420px] rounded-xl overflow-hidden shadow-lg"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d868.0672978382997!2d77.23322238391768!3d28.550453210001447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1762256781690!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Studio Sharan Location"
              />
            </motion.div>
          </div>

          {/* RIGHT COLUMN — CONTACT FORM */}
          <motion.div
            className="w-full"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <ContactForm />
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ContactPage;
